import React from 'react';

class VariableForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: props.data.id,
            varNum: props.data.varNum,
            name: props.data.name,
            positiveValue: props.data.positiveValue,
            calculationMethod: props.data.calculationMethod,
            dataType: props.data.dataType,
        };

        this.sendDataToParent = this.sendDataToParent.bind(this);
        this.removeSelf = this.removeSelf.bind(this);
    }

    removeSelf(){
        this.props.handleRemove(this.state.varNum);
    }

    sendDataToParent(){
        this.props.handleUpdate(this.state)
    }

    handleInputChange = (e) => {
        if (e.target.name === "name") {
            this.setState({ name: e.target.value},
                () => { this.sendDataToParent(); }
            );
        }
        else if (e.target.name === "positiveValue") {
            this.setState({ positiveValue: e.target.value},
                () => { this.sendDataToParent(); }
            );
        }
        else if (e.target.name === "calculationMethod") {
            this.setState({ calculationMethod: e.target.value},
                () => { this.sendDataToParent(); }
            );
        }
        else if (e.target.name === "dataType") {
            this.setState({ dataType: e.target.value},
                () => { this.sendDataToParent(); }
            );
        }
    };

    render() {
        return (
        <>
            <div style={{ padding: "20px", width: "30%", margin: "20px", backgroundColor: "lightgrey"}}>
                <div className="form-group">
                    <label>Name</label>
                    <input className="form-control" type="text" name="name" placeholder="Variable name"
                    value={this.state.name}
                    onChange={(e) => this.handleInputChange(e)} />
                </div>
                <div className="form-group">
                    <label>Positive value</label>
                    <input className="form-control" type="text" name="positiveValue"
                    value={this.state.positiveValue}
                    onChange={(e) => this.handleInputChange(e)} />
                </div>
                <div className="form-group">
                    <label>Calculation method</label>
                    <select className="form-control"  name="calculationMethod" onChange={(e) => this.handleInputChange(e)}
                            value={this.state.calculationMethod}>
                        <option value="NORMAL_DISTRIBUTION">Normal distribution</option>
                        <option value="LOG_TRANSFORMATION">Log transformation</option>
                        <option value="BINOMIAL_DISTRIBUTION">Binomial distribution</option>
                    </select>
                </div>
                <div className="form-group">
                    <label>Data type</label>
                    <select className="form-control"  name="dataType" onChange={(e) => this.handleInputChange(e)}
                            value={this.state.dataType}>
                        <option value="DOUBLE">Double</option>
                        <option value="LONG">Integer</option>
                        <option value="STRING">String</option>
                    </select>
                </div>
                <button type="button"
                    id="removePartButton" className="btn btn-danger" onClick={this.removeSelf} >
                    Remove variable
                </button>
            </div>
        </>
        );
    }
}

export default VariableForm;